import { render, staticRenderFns } from "./modelSelect.vue?vue&type=template&id=4f3661dd&scoped=true&lang=html"
import script from "./modelSelect.vue?vue&type=script&lang=js"
export * from "./modelSelect.vue?vue&type=script&lang=js"
import style0 from "./modelSelect.vue?vue&type=style&index=0&id=4f3661dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3661dd",
  null
  
)

export default component.exports